import React, {Component} from "react"

import {Entity} from "aframe-react"
import ActionButton from "./ActionButton"

import DeleteBtn from '../assets/icons/btn_delete.png'
import DepthMoveBtn from '../assets/icons/btn_z-index-hover.png'

import MagnifyBtn from '../assets/icons/btn-magnify.png'
import DecreaseBtn from '../assets/icons/btn-decrease.png'

import FadeAnimation from "./FadeAnimation"

import frameButton from "../components-aframe/frameButton"

class ItemActions extends Component {

    deleteButton() {
        return (
            <ActionButton
                src={DeleteBtn}

                position={{
                    x: -this.props.width/2, 
                    y: 0, 
                    z: 0.2
                }}

                button={true}

                events={{
                    clickUp: this.props.deleteClick
                }}

                visible={this.props.visible}

                
            />
        )
    }

    moveButton(texture, clickDown, yDir) {
        return (
           <ActionButton 
                src={texture}

                position={{
                    x: this.props.width/2, 
                    y: 0.8 * yDir, 
                    z: 0.2
                }}

                events={{
                    clickDown: clickDown,
                    clickUp: this.props.clickUp,
                    
                }}

                visible={this.props.visible}
            />
        )
    }

    render() {
        return (
            <Entity>
                
                {this.deleteButton()}

                {this.moveButton(MagnifyBtn, this.props.clickDownBackward, 1)}
                {this.moveButton(DecreaseBtn, this.props.clickDownForward, -1)}

            </Entity>
        );
    }
}

ItemActions.defaultProps = {
    width: 3,
    height: 3,

    visible: true,
}

export default ItemActions


// WEBPACK FOOTER //
// ./src/components/ItemActions.js